// extracted by mini-css-extract-plugin
export default {"form":"VendorForm_form__z8QaR","buttonRow":"VendorForm_buttonRow__f-aJZ","button":"VendorForm_button__TfVB-","cancelButton":"VendorForm_cancelButton__NIih2"};